/** Maps PeakNav shipment/unshipped API lines to fields expected by DashboardHelper. */
export function normalizePeakNavOrderLine(item: any): any {
    const quantity = item.qty != null ? item.qty : item.quantity;
    const deliveryCode = item.deliveryCode != null ? item.deliveryCode : item.deliverycode;
    const colorcode = item.colorcode != null ? item.colorcode : item.color;
    const topCollection =
        item.topCollection ||
        item.collectionname ||
        item.collection ||
        '';

    return {
        ...item,
        quantity,
        deliveryCode,
        colorcode,
        topCollection,
        amount: item.amount != null ? item.amount : 0,
    };
}
